<script>
import { listFunnels, getMaxId } from "../../../api/crm";
import { searchUserList } from "../../../api/auth/user";
import { searchOrganizationList } from "../../../api/auth/organization";
import { getDict } from "../../../api/dict";
import moment from "moment";
export default {
  data() {
    return {
      list: [],
      dialogFormVisible: false,
      dialogTableVisible: false,
      anniu: false,
      options: [],
      value: [],
      list: [],
      options8: [],
      loading: false,
      selectedProvince: {},
      multipleSelection: [],
      selectedCity: {},
      recordsIds: [],
      companyDetail: {},
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      fileList: [],
      formLabelWidth: "120px",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showSizeChanger: true
      },
      zsArray: [],
      select: {
        searchParam: "",
        reportStartTime: "",
        reportEndTime: "",
        isorder: "",
        state: "",
        px: "0"
      },
      Ttitle: "",
      CCresult: "",
      value2: "",
      pageNo: 1,
      limit: 50,
      total: 0,
      formLabelWidth: "120px",
      companyList: [],
      isCompanyLoading: false,
      allA: {},
      allowTJ: false,
      zzid: "",
      p: "",
      youid: "",
      search: {
        industryClassification: "",
        businessType: "",
        projectname: "",
        customerUnit: "",
        salesman: "",
        currentStage: "",
        determine: ""
      },
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      options7: [],
      options8: [],
      authorities: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  async created() {
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a?.length) {
      this.authorities = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
  },
  mounted() {},
  methods: {
    async translate() {
      this.options3 = await this.getOption("industryClassification");
      this.options4 = await this.getOption("businessType");
      this.options5 = await this.getOption("currentStage");
      this.options6 = await this.getOption("winPercent");
      this.options7 = await this.getOption("determine");
      this.options8 = await this.getOption("informationSources");
      this.ListC();
    },
    async Select() {
      await this.ListC();
    },
    refresh() {
      this.select.searchParam = "";
      this.value2 = "";
      this.select.state = "";
      this.select.isorder = "";
      this.select.reportStartTime = "";
      this.select.reportEndTime = "";
    },
    async getOption(a) {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      const result = await getDict(lang, a);
      if (result.code == 0) {
        result.data.content.unshift({
          id: 555555,
          text: this.$t('common.all'),
          value: ""
        });
        return result.data.content;
      }
    },
    async ListC(pager = 1) {
      this.pageNo = pager;
      const formdata = new FormData();
      formdata.append(
        "industryClassification",
        this.search.industryClassification
      );
      formdata.append("businessType", this.search.businessType);
      formdata.append("projectname", this.search.projectname);
      formdata.append("customerUnit", this.search.customerUnit);
      formdata.append("salesman", this.search.salesman);
      formdata.append("currentStage", this.search.currentStage);
      formdata.append("determine", this.search.determine);
      const result = await listFunnels(this.pageNo, this.limit, formdata);
      if (result.code == 0) {
        this.total = result.data.total;
        result.data.records.forEach(e => {
          if (e.industryClassification && e.industryClassification != null) {
            e.industryClassification1 = this.options3.find(
              ee => ee.value == e.industryClassification
            ).text;
          }
          if (e.businessType && e.businessType != null) {
            e.businessType1 = this.options4.find(
              ee => ee.value == e.businessType
            ).text;
          }
          if (e.currentStage && e.currentStage != null) {
            e.currentStage1 = this.options5.find(
              ee => ee.value == e.currentStage
            ).text;
          }
          if (e.winPercent && e.winPercent != null) {
            e.winPercent1 = this.options6.find(
              ee => ee.value == e.winPercent
            ).text;
          }
          if (e.determine && e.determine != null) {
            e.determine1 = this.options7.find(
              ee => ee.value == e.determine
            ).text;
          }
        });
        this.list = result.data.records;
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async ListC1(val) {
      this.limit = val;
      const formdata = new FormData();

      formdata.append(
        "industryClassification",
        this.search.industryClassification
      );
      formdata.append("businessType", this.search.businessType);
      formdata.append("projectname", this.search.projectname);
      formdata.append("customerUnit", this.search.customerUnit);
      formdata.append("salesman", this.search.salesman);
      formdata.append("currentStage", this.search.currentStage);
      formdata.append("determine", this.search.determine);
      const result = await listFunnels(this.pageNo, this.limit, formdata);
      if (result.code == 0) {
        this.total = result.data.total;
        result.data.records.forEach(e => {
          if (e.industryClassification && e.industryClassification != null) {
            e.industryClassification1 = this.options3.find(
              ee => ee.value == e.industryClassification
            ).text;
          }
          if (e.businessType && e.businessType != null) {
            e.businessType1 = this.options4.find(
              ee => ee.value == e.businessType
            ).text;
          }
          if (e.currentStage && e.currentStage != null) {
            e.currentStage1 = this.options5.find(
              ee => ee.value == e.currentStage
            ).text;
          }
          if (e.winPercent && e.winPercent != null) {
            e.winPercent1 = this.options6.find(
              ee => ee.value == e.winPercent
            ).text;
          }
          if (e.determine && e.determine != null) {
            e.determine1 = this.options7.find(
              ee => ee.value == e.determine
            ).text;
          }
        });
        this.list = result.data.records;
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async routeTo(row) {
      const formdata = new FormData();
      formdata.append("id", row.recordId);
      const result = await getMaxId(formdata);
      if (result.code == 0) {
        this.$router.push({
          path: "/recordsListDetail",
          query: { id: result.data }
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    }
  }
};
</script>

<template>
  <div>
    <el-table :data="list" border ref="multipleTable">
      <el-table-column
        prop="industryClassification1"
        label="行业分类"
        width="120"
      >
        <template #header>
          <div>{{ $t('funnel.industryClassification') }}</div>
          <el-select
            v-model="search.industryClassification"
            @change="ListC()"
          >
            <el-option
              v-for="item in options3"
              :key="item.id"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="businessType1" label="业务类型" width="120">
        <template #header>
          <div>{{ $t('funnel.businessType') }}</div>
          <el-select
            v-model="search.businessType"
            @change="ListC()"
          >
            <el-option
              v-for="item in options4"
              :key="item.id"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="projectname" label="项目名称" width="100">
        <template #header>
          <div>{{ $t('funnel.projectName') }}</div>
          <el-input v-model="search.projectname" @change="ListC()"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="customerUnit" label="客户单位" width="200">
        <template #header>
          <div>{{ $t('common.customerName') }}</div>
          <el-input v-model="search.customerUnit" @change="ListC()"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="salesman" label="销售员" width="120">
        <template #header>
          <div>{{ $t('common.salesMen') }}</div>
          <el-input v-model="search.salesman" @change="ListC()"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" :label="$t('funnel.startTime')" width="120">
      </el-table-column>
      <el-table-column prop="budgetedAmount" :label="$t('funnel.budgetedAmount')" width="150">
      </el-table-column>
      <el-table-column prop="currentStage1" label="当前阶段" width="120">
        <template #header>
          <div>{{ $t('funnel.currentStage') }}</div>
          <el-select
            v-model="search.currentStage"
            @change="ListC()"
          >
            <el-option
              v-for="item in options5"
              :key="item.id"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="winPercent1" :label="$t('funnel.winPercent')" width="120">
      </el-table-column>

      <el-table-column prop="expectedOutput" :label="$t('funnel.expectedOutput')" width="100">
      </el-table-column>
      <el-table-column prop="contractAmount" :label="$t('funnel.contractAmount')" width="100">
      </el-table-column>
      <el-table-column
        prop="customerLeadDepartment"
        :label="$t('funnel.customerLeadDepartment')"
        width="120"
      >
      </el-table-column>
      <el-table-column prop="relevantContact" :label="$t('funnel.relevantContact')" width="110">
      </el-table-column>
      <el-table-column
        prop="customerStakeholders"
        :label="$t('funnel.customerStakeholders')"
        width="100"
      >
      </el-table-column>
      <el-table-column prop="keyman" :label="$t('funnel.customerStakeholders')" width="100">
      </el-table-column>
      <el-table-column prop="demandContent" :label="$t('funnel.demandContent')" width="120">
      </el-table-column>
      <el-table-column prop="currentProgress" :label="$t('funnel.currentProgress')" width="120">
      </el-table-column>
      <el-table-column
        prop="nextVisitTime"
        :label="$t('funnel.nextVisitTime')"
        width="120"
      >
      </el-table-column>
      <el-table-column prop="competitor" :label="$t('funnel.competitor')" width="120">
      </el-table-column>
      <el-table-column prop="visitContent" :label="$t('funnel.visitContent')" width="120">
      </el-table-column>
      <el-table-column prop="cooperativePartner" :label="$t('funnel.cooperativePartner')" width="120">
      </el-table-column>
      <el-table-column prop="determine1" label="判定" width="120">
        <template #header>
          <div>{{ $t('funnel.determine') }}</div>
          <el-select
            v-model="search.determine"
            @change="ListC()"
          >
            <el-option
              v-for="item in options7"
              :key="item.id"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="failureReason" :label="$t('funnel.failureReason')" width="120">
      </el-table-column>
      <!-- <el-table-column prop="informationSources" label="消息来源" width="110">
      </el-table-column> -->

      <el-table-column :label="$t('common.operation')" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="routeTo(scope.row)">{{ $t('funnel.details') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="ListC1"
      @current-change="ListC"
      :pager-count="9"
      :current-page="pageNo"
      :page-size="limit"
      :page-sizes="[50, 100, 150, 200]"
      :background="true"
      layout="prev, pager, next, jumper,->, sizes,total"
      :total="total"
      style="margin-top: 10px;"
    />
  </div>
</template>

<style scoped lang="less">
.layout-container-demo .el-main {
  padding: 0;
}

.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}

:deep(.el-icon svg) {
  color: inherit !important;
}

input.file {
  display: none;
}

.dotClass {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin-left: 10px;
}
/deep/ .el-table .warning-row {
  background: #f4f207;
}

/deep/ .el-table__body .success-row {
  color: black;
  background: #00ff66;
}
/deep/ .el-table__body .isorder-row {
  color: white;
  background: #5f5f5f;
}
/deep/ .el-table {
  // 每行鼠标经过得样式
  .el-table__body tr td {
    background-color: unset !important;
  }
}
</style>
